// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2ixzB","label":"LabeledBox_label__2pYuZ"};